import React from 'react';

import { PageSection } from '@app/pages/MainPage/ValueInclusive/PageSection';
import { Bullet } from '@app/pages/MainPage/ValueInclusive/Bullet';

import { SearchValuInclusiveUrl } from '@app/constants/url.constants';
import { Package } from '@app/pages/MainPage/ValueInclusive/types';

import {
	ButtonVariant,
	ActionMode,
	Button,
} from '@app/components/Button/Button';

import background from '@image/valueinclusive/featured.png';

interface OwnProps {
	items: Array<Package>;
}

export const Intro: React.FC<OwnProps> = (props: OwnProps) => (
	<PageSection
		alignHeader="center"
		header={(
			<span style={{ justifyContent: 'center' }}>
				<span className="text-uppercase">Value Inclusive </span>
				<span className="font-family_decorative font-weight_light text-header__highlight">Package® (VIP)</span>
			</span>
		)}
		footer={(
			<div className="section-footer">
				<div className="bullets">
					<Bullet
						icon="https://www.onlinevacationcenter.com/images/icons/cruise-blue.png"
						header="Cruise"
						text="Advantage Cruise Fares"
					/>
					<Bullet
						icon="https://www.onlinevacationcenter.com/images/icons/air-blue.png"
						header="Airfare"
						text="Economy Air & Transfers"
					/>
					<Bullet
						icon="https://www.onlinevacationcenter.com/images/icons/hotels-blue.png"
						header="Hotel"
						text="4★ Central Hotels"
					/>
					<Bullet
						icon="https://www.onlinevacationcenter.com/images/icons/obc-blue.png"
						header="Perks"
						text="Exclusive Onboard Extras"
					/>
				</div>

				<Button
					variant={ButtonVariant.Filled}
					action={ActionMode.InternalLink}
					link={SearchValuInclusiveUrl}
				>
					View {props.items[0]?.vipDealsCount} Exclusive Packages
				</Button>
			</div>
		)}
	>
		<img
			alt=""
			src={background}
			className="page-section__cover"
		/>

		<p className="text-size_medium">
			Our exclusive Value Inclusive Packages offer an all-in-one approach to your cruise vacation,
			combining convenience, affordability and industry expertise into one enticing bundle.
			These packages include popular cruise itineraries, airfare, handpicked hotels, transportation,
			and special amenities at a discounted rate compared to booking each component separately.
			Plus, our dedicated team takes care of the details to make your experience streamlined and
			hassle-free. Explore the world with ease—see our best-selling packages below!
		</p>
	</PageSection>
);
